import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('workstationModule', ['workStationList', 'currentStation', 'workStationMap'])
  }
}
